import { TypedDocumentNode, gql } from '@apollo/client';
import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Video } from '@sorare/core/src/atoms/ui/Video';
import { ListWithDetailLayoutWrapper } from '@sorare/core/src/components/layout/ListWithDetailLayout';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { LANDING } from '@sorare/core/src/constants/__generated__/routes';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { withRouteQuery } from '@sorare/core/src/lib/navigation/withRouteQuery';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LeagueRewardItem } from 'components/rivalsUserGroup/LeagueRewardItem';

import {
  LoggedOutRivalsLeaguesPrizePoolPageQuery,
  LoggedOutRivalsLeaguesPrizePoolPageQueryVariables,
} from './__generated__/page.graphql';

const StyledVideo = styled(Video)`
  object-fit: contain;
  @media ${desktopAndAbove} {
    height: var(--area-height);
  }
`;
const Wrapper = styled(Vertical)`
  padding: var(--double-unit);
  @media ${desktopAndAbove} {
    max-height: var(--area-height);
  }
`;

const LOGGED_OUT_RIVALS_LEAGUES_PRIZE_POOL_PAGE_QUERY = gql`
  query LoggedOutRivalsLeaguesPrizePoolPageQuery {
    football {
      rivals {
        id
        userGroupTournament {
          id
          rewardsConfig {
            ranking {
              fromRank
              toRank
              ...LeagueRewardItem_so5RewardConfig
            }
          }
        }
      }
    }
  }
  ${LeagueRewardItem.fragments.so5RewardConfig}
` as TypedDocumentNode<
  LoggedOutRivalsLeaguesPrizePoolPageQuery,
  LoggedOutRivalsLeaguesPrizePoolPageQueryVariables
>;

const messages = defineMessages({
  title: {
    id: 'LoggedOutRivalsLeaguesPrizePoolPage.title',
    defaultMessage: 'Prize Pool',
  },
});
export default withRouteQuery(
  ({ queryResult }) => {
    const { rewardsConfig } =
      queryResult.data?.football.rivals.userGroupTournament || {};
    const isDesktopAndAbove = useIsDesktopAndAbove();
    return (
      <>
        <PageHeader backTo={LANDING} text={messages.title} />
        <ListWithDetailLayoutWrapper>
          {!isDesktopAndAbove && (
            <StyledVideo
              controls
              playsInline
              poster="https://frontend-assets.sorare.com/football/zz-poster.jpg"
              sources={[
                {
                  src: 'https://frontend-assets.sorare.com/videos/rivals_leagues.mp4',
                  type: 'video/mp4',
                },
              ]}
            />
          )}
          <Wrapper>
            {rewardsConfig?.ranking?.map(so5RewardConfig => (
              <LeagueRewardItem
                key={`${so5RewardConfig.fromRank}-${so5RewardConfig.toRank}`}
                so5RewardConfig={so5RewardConfig}
              />
            ))}
          </Wrapper>
          {isDesktopAndAbove && (
            <StyledVideo
              controls
              playsInline
              poster="https://frontend-assets.sorare.com/football/zz-poster.jpg"
              sources={[
                {
                  src: 'https://frontend-assets.sorare.com/videos/rivals_leagues.mp4',
                  type: 'video/mp4',
                },
              ]}
            />
          )}
        </ListWithDetailLayoutWrapper>
      </>
    );
  },
  {
    query: LOGGED_OUT_RIVALS_LEAGUES_PRIZE_POOL_PAGE_QUERY,
  }
);
